import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import ValidatedField from 'ui-kit/components/validated-field';
import DatePicker, { type S as DatePickerSig } from '../date-picker';

export interface ChangesetDatePickerSignature {
  Element: HTMLDivElement;
  Args: Pick<
    DatePickerSig['Args'],
    'formatter' | 'disabled' | 'isReadOnly' | 'isMandatory' | 'labelName'
  > & {
    propertyName: string;
    onChange?: DatePickerSig['Args']['onChange'];

    onChangesetUpdate?: (
      changeset: EmberChangeset,
      propertyName: string
    ) => void;
    changeset: EmberChangeset;
  };
}

export default class ChangesetDatePicker extends Component<ChangesetDatePickerSignature> {
  onChange = value => {
    if (this.args.onChange) {
      this.args.onChange(value);
    } else {
      this.args.changeset.set(this.args.propertyName, value);
    }
    this.args.onChangesetUpdate?.(this.args.changeset, this.args.propertyName);
  };

  <template>
    <ValidatedField
      @propertyName={{@propertyName}}
      @changeset={{@changeset}}
      @errorClass='error-validated-input-display'
    >
      <DatePicker
        @propertyName={{@propertyName}}
        @selected={{changesetGet @changeset @propertyName}}
        @isReadOnly={{@isReadOnly}}
        @disabled={{@disabled}}
        @labelName={{@labelName}}
        @isMandatory={{@isMandatory}}
        @onChange={{this.onChange}}
        @formatter={{@formatter}}
        ...attributes
      />
    </ValidatedField>
  </template>
}
